import { createSlice } from '@reduxjs/toolkit';
import { Order } from '@src/components/Main/Chat/ChatMessage/ChatMessage';

interface OrderState {
	allOrders: Order[] | [];
}

const initialState: OrderState = {
	allOrders: [],
};

export const orderSlice = createSlice({
	name: 'order',
	initialState,
	reducers: {
		setAllOrders: (state, action) => {
			state.allOrders = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setAllOrders } = orderSlice.actions;

export default orderSlice.reducer;
